import { render, staticRenderFns } from "./PhotosCarousel.vue?vue&type=template&id=16105927&scoped=true&lang=pug&"
import script from "./PhotosCarousel.vue?vue&type=script&lang=js&"
export * from "./PhotosCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PhotosCarousel.vue?vue&type=style&index=0&id=16105927&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16105927",
  null
  
)

export default component.exports